import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import Questionnaire1Screen from '~/pages/homes/sti-testing/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/sti-testing/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/sti-testing/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/sti-testing/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/sti-testing/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/sti-testing/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/sti-testing/Questionnaire7Screen';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {STI_TESTING_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const STITesting = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case STI_TESTING_KEYS.START:
        trackPageViewGA('/sti-testing/start', 'MDQ-STI Testing - Start');
        return <Questionnaire1Screen />;
      case STI_TESTING_KEYS.PROFILE:
        trackPageViewGA('/sti-testing/profile', 'MDQ-STI Testing - Profile');
        return <Questionnaire2Screen />;
      case STI_TESTING_KEYS.INVALID:
        trackPageViewGA('/sti-testing/invalid', 'MDQ-STI Testing - Invalid');
        return <Questionnaire3Screen />;
      case STI_TESTING_KEYS.WHY_THINKING_STI_TEST:
        trackPageViewGA('/sti-testing/why-thinking-sti-test', 'MDQ-STI Testing - Why Thinking STI Test');
        return <Questionnaire4Screen />;
      case STI_TESTING_KEYS.MORE_INFORMATION:
        trackPageViewGA('/sti-testing/more-information', 'MDQ-STI Testing - More Information');
        return <Questionnaire5Screen />;
      case STI_TESTING_KEYS.SAMPLE_COLLECTION_LOCATION:
        trackPageViewGA('/sti-testing/sample-collection-location', 'MDQ-STI Testing - Sample Collection Location');
        return <Questionnaire6Screen />;
      case STI_TESTING_KEYS.CHOOSE_MEDICATION:
        trackPageViewGA('/sti-testing/choose-medication', 'MDQ-STI Testing - Choose Medication');
        return <Questionnaire7Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default STITesting;
